import React from 'react';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import AirIcon from '@mui/icons-material/Air';
import BoltIcon from '@mui/icons-material/Bolt';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import TuneIcon from '@mui/icons-material/Tune';

const getServiceIcon = (title) => {
  if (title.includes('Installation')) {
    return <BuildCircleIcon fontSize="small" />;
  }

  if (title.includes('Repair')) {
    return <AcUnitIcon fontSize="small" />;
  }

  if (title.includes('Maintenance')) {
    return <TuneIcon fontSize="small" />;
  }

  if (title.includes('Air Quality')) {
    return <AirIcon fontSize="small" />;
  }

  return <BoltIcon fontSize="small" />;
};

const ServiceDetailCard = ({ title, description, bullets }) => (
  <article className="card service-card service-detail-card">
    <div className="service-card-icon" aria-hidden="true">
      {getServiceIcon(title)}
    </div>
    <h3>{title}</h3>
    <p>{description}</p>
    <ul className="service-detail-list">
      {bullets.map((bullet) => (
        <li key={bullet}>{bullet}</li>
      ))}
    </ul>
  </article>
);

export default ServiceDetailCard;
